import {checkIfNeutralPlayer} from "../players/checkIfNeutralPlayer";

/**
 * Сводка захвата городов конца раунда по игрокам — для модалки захвата:
 * сколько городов игрок захватил и потерял, на сколько изменились его очки,
 * доход очков и доход монет. Считается редьюсером CAPTURE_CITIES по игрокам до
 * и после захвата (доход после захвата пересчитан по новым городам) и лежит в
 * gameState.lastCityCaptureStats рядом с lastCapturedCities.
 *
 * В сводку попадают только игроки, которые что-то захватили или потеряли.
 * Нейтральный игрок — не соперник: его строки нет, а города, отнятые у
 * нейтралов, видны в строке захватчика.
 *
 * @param {Object[]} capturedCities - захваты ({fromPlayer, toPlayer, ...})
 * @param {Object[]} playersBefore - игроки до захвата
 * @param {Object[]} playersAfter - игроки после захвата
 * @returns {{playerId: string, capturedCount: number, lostCount: number,
 *   winPointsDelta: number, coinsIncomeDelta: number, winPointsIncomeDelta: number}[]}
 *   в порядке игроков партии
 */
export const buildCityCaptureStats = (capturedCities, playersBefore, playersAfter) => {
  const countsById = new Map();
  const getCounts = (playerId) => {
    if (!countsById.has(playerId)) {
      countsById.set(playerId, {capturedCount: 0, lostCount: 0});
    }
    return countsById.get(playerId);
  };

  (capturedCities || []).forEach(({fromPlayer, toPlayer}) => {
    if (toPlayer && !checkIfNeutralPlayer(toPlayer.id)) {
      getCounts(toPlayer.id).capturedCount += 1;
    }
    if (fromPlayer && !checkIfNeutralPlayer(fromPlayer.id)) {
      getCounts(fromPlayer.id).lostCount += 1;
    }
  });

  const delta = (before, after, field) => (Number(after?.[field]) || 0) - (Number(before?.[field]) || 0);

  return (playersAfter || [])
    .filter((player) => countsById.has(player.id))
    .map((player) => {
      const before = (playersBefore || []).find(({id}) => id === player.id);
      return {
        playerId: player.id,
        ...countsById.get(player.id),
        winPointsDelta: delta(before, player, 'winPoints'),
        coinsIncomeDelta: delta(before, player, 'coinsIncome'),
        winPointsIncomeDelta: delta(before, player, 'winPointsIncome'),
      };
    });
};
